"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    n = function n() {
  return null;
};

exports.useDerivedState = function (u, r) {
  var t,
      l,
      a = e.useState(u),
      o = a[0],
      v = a[1],
      c = e.useRef(null !== (t = r.value) && void 0 !== t ? t : u);
  c.current = null !== (l = r.value) && void 0 !== l ? l : u;
  var i = e.useCallback(function (e) {
    var u;
    return (null !== (u = r.onChange) && void 0 !== u ? u : n)("function" == typeof e ? e(c.current) : e);
  }, [r.onChange]);
  return null != r.value || null != r.onChange ? [c.current, i] : [o, v];
};